export default __webpack_public_path__ + "static/media/chartink-logo.dca447ce.png";